import { render, staticRenderFns } from "./table-released.vue?vue&type=template&id=14735739"
import script from "./table-released.vue?vue&type=script&lang=js"
export * from "./table-released.vue?vue&type=script&lang=js"
import style0 from "./table-released.vue?vue&type=style&index=0&id=14735739&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports